import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UserAvatarComponent } from '@y42/user/shared/user-avatar';
import { JobTriggeredByUserAvatarComponent } from './job-triggered-by-user-avatar.component';

@NgModule({
  imports: [CommonModule, UserAvatarComponent, MatTooltipModule],
  exports: [JobTriggeredByUserAvatarComponent],
  declarations: [JobTriggeredByUserAvatarComponent],
  providers: [],
})
export class JobTriggeredByUserAvatarModule {}
